import React from "react";
import PropTypes from "prop-types";
import utils from "@utils";

/**
 * Renders a single payment history item row displaying comments and amount.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Object} props.item - The payment history item data.
 * @param {string|number} props.item.Id - Unique identifier for the payment item.
 * @param {string} props.item.Comments - Comments or description for the payment.
 * @param {number} props.item.Amount - Amount of the payment.
 * @returns {JSX.Element} The rendered payment history item.
 */
const PaymentHistoryItem = ({ item }) => (
    <div
      className="row"
    >
      <div className="col-xs-9">
        <em>{item.Comments}</em>
      </div>
      <div className="col-xs-3">
        <em>{utils.currencyFormatter(item.Amount)}</em>
      </div>
    </div>
  );

PaymentHistoryItem.propTypes = {
  item: PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    Comments: PropTypes.string,
    Amount: PropTypes.number.isRequired
  }).isRequired
};

export default PaymentHistoryItem;
